/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 

 /* Image ANimation Custom */

 window.addEventListener('DOMContentLoaded', function(){
   const animationContainers = document.querySelectorAll('.CustomAnimation__Container');
 
   for (const animationContainer of animationContainers) {
     const innerContainer = animationContainer.querySelector('.CustomAnimation__Container--inner');
     const images = animationContainer.querySelectorAll('.CustomAnimation__Image');
     const imageHeight = images[0].getBoundingClientRect().height;
     animationContainer.style.height = `${imageHeight * 2.5}px`;
 
     window.addEventListener('resize', function() {
       animationContainer.style.height = `${images[0].getBoundingClientRect().height * 2.5}px`;
     });
 
     innerContainer.classList.add('active');
   }
 });
 
 
 /* Popular Formulas Flickity */
 
 window.addEventListener('DOMContentLoaded', function() {
   const popularFormulaContainers = document.querySelectorAll('.PopularFormulas__Blocks');
 
   for (const popularFormulaContainer of popularFormulaContainers) {
     const flkty = new Flickity(popularFormulaContainer, {
       contain: true,
       cellAlign: "left",
       prevNextButtons: false,
       pageDots: false,
       watchCSS: true,
       groupCells: true
     });
 
     const prevButton = popularFormulaContainer.closest('.PopularFormulas__Container').querySelector('.PopularFormulas__NavButton--left');
     const nextButton = popularFormulaContainer.closest('.PopularFormulas__Container').querySelector('.PopularFormulas__NavButton--right');
     const lastElement = popularFormulaContainer.querySelector('.PopularFormula__Block:last-child');
 
     if (flkty && prevButton && nextButton) {
       popularFormulaContainer.style.setProperty('--card-height', `${popularFormulaContainer.getBoundingClientRect().height}px`);
       prevButton.addEventListener('click', function() {
         flkty.previous();
       });
 
       nextButton.addEventListener('click', function() {
         flkty.next();
       });
       
       flkty.on( 'select', function() {
         if (flkty.selectedIndex === 0) {
           prevButton.style.opacity = ".3";
           prevButton.style.pointerEvents = "none";
           popularFormulaContainer.classList.remove('hide-left');
         } else {
           prevButton.style.opacity = "1";
           prevButton.style.pointerEvents = "unset";
           popularFormulaContainer.classList.add('hide-left');
         }
     
         if (flkty.selectedElements.includes(lastElement)) {
           nextButton.style.opacity = ".3";
           nextButton.style.pointerEvents = "none";
           popularFormulaContainer.classList.remove('hide-right');
         } else {
           nextButton.style.opacity = "1";
           nextButton.style.pointerEvents = "unset";
           popularFormulaContainer.classList.add('hide-right');
         }
       });
     }
   }
 });
 
 window.addEventListener('DOMContentLoaded', function() {
   /* Product Flickity Nav */
   /* Main Gallery */
   
   const galleryContainer = document.querySelector('.Product__Slideshow');
   if (galleryContainer) {
     const flkty = new Flickity('.Product__Slideshow');
     const prevButton = document.querySelector('.ProductSliderLeft--mobile');
     const nextButton = document.querySelector('.ProductSliderRight--mobile');
 
     if (flkty && prevButton && nextButton) {
       prevButton.addEventListener('click', function() {
         flkty.previous();
       });
   
       nextButton.addEventListener('click', function() {
         flkty.next();
       });
     }
   
     flkty.on( 'select', function() {
       if (flkty.selectedIndex === 0) {
         prevButton.style.display = "none";
       } else {
         prevButton.style.display = "block";
       }
   
       if (flkty.selectedIndex === flkty.cells.length - 1) {
         nextButton.style.display = "none";
       } else {
         nextButton.style.display = "block";
       }
     });
   }
   
   /* Thumbnail */
   const productSliderContainer = document.querySelector('.ProductSlider--container');
   if (productSliderContainer) {
     const flickityElement = productSliderContainer.querySelector('.Product__SlideshowNavScroller');
     const flkty = new Flickity(flickityElement, {
       cellAlign: 'left',
       contain: true,
       prevNextButtons: false,
       pageDots: false,
       asNavFor: '.Product__Slideshow'
     });
     const prevButton = productSliderContainer.querySelector('.ProductSliderLeft--desktop');
     const nextButton = productSliderContainer.querySelector('.ProductSliderRight--desktop');
   
     if (flkty && prevButton && nextButton) {
       prevButton.addEventListener('click', function() {
         flkty.previous();
         flkty.selectedElement.click();
       });
   
       nextButton.addEventListener('click', function() {
         flkty.next();
         flkty.selectedElement.click();
       });
     }
   
     flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
        flkty.select(cellIndex);
     });
   
     flkty.on( 'select', function() {
       if (flkty.selectedIndex === 0) {
         prevButton.style.display = "none";
       } else {
         prevButton.style.display = "block";
       }
   
       if (flkty.selectedIndex === flkty.cells.length - 1) {
         nextButton.style.display = "none";
       } else {
         nextButton.style.display = "block";
       }
     });
   }
 });
 
 /* Product pop up */
 
 window.addEventListener('DOMContentLoaded', function() {
   const popupContainers = document.querySelectorAll('.PopupInfo__Content');
 
   let mobile = false;
   if (window.innerWidth <= 1007) {
     mobile = true;
   }
 
   window.addEventListener('resize', function() {
     if (window.innerWidth <= 1007) {
       mobile = true;
     } else {
       mobile = false;
     }
   });
 
   for (const popupContainer of popupContainers) {
     const popupDescription = popupContainer.querySelector('.PopupInfo__Description');
     const popupButton = popupContainer.querySelector('.PopupInfo__Content--title');
     const popupClose = popupDescription.querySelector('.PopupInfo__Description--title');
 
     window.addEventListener('click', function(e) {
       if (popupDescription.classList.contains('active') && e.target != popupButton && e.target != popupDescription && !(popupDescription.contains(e.target))) {
         popupDescription.classList.remove('active');
 
         if (mobile) {
           document.querySelector('.PageOverlay-2').classList.remove('is-visible');
           document.documentElement.style.overflow = 'unset';
         }
       }
     });
 
     popupButton.addEventListener('click', function() {
       popupDescription.classList.add('active');
       if (mobile) {
         document.querySelector('.PageOverlay-2').classList.add('is-visible');
         document.documentElement.style.overflow = 'hidden';
       }
     });
 
     popupClose.addEventListener('click', function() {
       popupDescription.classList.remove('active');
 
       if (mobile) {
         document.querySelector('.PageOverlay-2').classList.remove('is-visible');
         document.documentElement.style.overflow = 'unset';
       }
     });
   }
 });
 
 /* Guarantee section */
 
 window.addEventListener('DOMContentLoaded', function() {
   const guaranteeContainers = document.querySelectorAll('.Guarantees__Container');
 
   for (const guaranteeContainer of guaranteeContainers) {
     const guaranteeSelects = guaranteeContainer.querySelectorAll('.Guarantees__SelectBlock');
     const guaranteeContents = guaranteeContainer.querySelectorAll('.Guarantee__ContentBlock');
   
     for (let i = 0; i < guaranteeSelects.length; i++) {
       guaranteeSelects[i].addEventListener('click', function() {
         guaranteeContainer.querySelector('.Guarantee__ContentBlock.active').classList.remove('active');
         guaranteeContainer.querySelector('.Guarantees__SelectBlock.active').classList.remove('active');
         guaranteeSelects[i].classList.add('active');
         guaranteeContents[i].classList.add('active');
       });
     }
   }
 });
 
 /**
 * ----------------------------------------------------------------------------
 * Collection Read More 
 * ----------------------------------------------------------------------------
 */
 
 window.addEventListener('DOMContentLoaded', function() {
   const collectionDescription = document.querySelector('.Collection__Description');
   if(collectionDescription) {
     const collectionReadMore = collectionDescription.querySelector('.Collection__ReadMore')
     collectionReadMore.addEventListener('click', function() {
       collectionDescription.classList.toggle('open');
     });
   }
 });
 
 /**
 * ----------------------------------------------------------------------------
 * Savings amount calculation for PDP and PLP
 * ----------------------------------------------------------------------------
 */
 
 window.addEventListener('DOMContentLoaded', function() {
   const productPage = document.querySelector('.Product');
 
   if (!productPage) {
     return;
   }
 
   const forms = productPage.querySelectorAll('form[action="/cart/add"]');
 
   for (const form of forms) {
     const singleUnitPriceContainer = form.querySelector('[data-single-unit-price]');
 
     if (!singleUnitPriceContainer) {
       continue;
     }
 
     const singleUnitPrice = Number(singleUnitPriceContainer.getAttribute('data-single-unit-price'));
     const wholeSaleOptions = form.querySelectorAll('[data-wholesale-amount]');
 
     for (const wholeSaleOption of wholeSaleOptions) {
       const discountedPrice = Number(wholeSaleOption.getAttribute('data-multi-unit-price'));
       const wholeSaleAmount = Number(wholeSaleOption.getAttribute('data-wholesale-amount'));
 
       if (isNaN(discountedPrice) || isNaN(wholeSaleAmount)) {
         continue;
       }
 
       const supposedPrice = singleUnitPrice * wholeSaleAmount;
       const priceDifference = supposedPrice - discountedPrice;
       const convertedPriceDifference = window.Currency.formatMoney(priceDifference, window.theme.moneyFormat);
       wholeSaleOption.dataset.savePrice = priceDifference;
 
       wholeSaleOption.innerText = convertedPriceDifference;
 
     }
   }
 });
 
 /**
 * ----------------------------------------------------------------------------
 * Stage selector handling for PLP
 * ----------------------------------------------------------------------------
 */
 
 window.addEventListener('DOMContentLoaded', function() {
   const stageSelectors = document.querySelectorAll('[name^="stage-"]');
   const stageForms = document.querySelectorAll('form[data-stage]');
   
   for (const stageSelector of stageSelectors) {
     stageSelector.addEventListener('change', function(e) {
       e.preventDefault();
       const stage = e.target.value;
       const currentForm = e.target.closest('.ProductForm');
       
       const subscriptionContainer = currentForm.querySelector('.appstle_subscription_wrapper');
       if(subscriptionContainer) {
         if (subscriptionContainer.querySelector('.appstle_subscription_radio_wrapper [name="selling_plan"]:checked')) {
           /* If subscription is checked */
           subscriptionContainer.querySelector('.appstle_include_dropdown').classList.add('active-option');
           subscriptionContainer.querySelector('.appstle_subscription_wrapper_option:not(.appstle_include_dropdown)').classList.remove('active-option');
         } else {
           /* If one time is checked */
           subscriptionContainer.querySelector('.appstle_include_dropdown').classList.remove('active-option');
           subscriptionContainer.querySelector('.appstle_subscription_wrapper_option:not(.appstle_include_dropdown)').classList.add('active-option');
         }
       }
       
 
       for (const stageForm of stageForms) {
         const stageFormInputs = stageForm.querySelectorAll('input[name^="stage-"]');
 
         if (stageForm.dataset.stage === stage) {
           stageForm.setAttribute("aria-hidden", "false");
         } else {
           stageForm.setAttribute("aria-hidden", "true");
         }
 
         for (const stageFormInput of stageFormInputs) {
           if (stageFormInput.value === stage) {
             stageFormInput.setAttribute("checked", "");
             stageFormInput.checked = true;
           } else {
             stageFormInput.removeAttribute("checked");
             stageFormInput.checked = false;
           }
         }
       }
       
     });
   }
 });
 
 /**
 * ----------------------------------------------------------------------------
 * Update "Add to Bag" button price, with or without subscription
 * ----------------------------------------------------------------------------
 */
 
 
 window.addEventListener('DOMContentLoaded', function() {
   const productPage = document.querySelector('.Product');
 
   if (!productPage) {
     return;
   }
 
   const isLandingPage = productPage.querySelectorAll('form[action="/cart/add"]').length > 1;
 
   if (isLandingPage) {
     waitToLoadAllSubscriptionForms();
   } else {
     waitToLoadSubscriptionForm();
   }
 
   function waitToLoadSubscriptionForm() {
     const observerTarget = document.querySelector('#appstle-subscription-widget-placeholder').parentNode;
 
     if (!observerTarget) {
       return;
     }
 
     const observer = new MutationObserver(function(mutations) {
       for (const mutation of mutations) {
         if (mutation.type === 'childList' && mutation.target.classList.contains('transcy-money')) {
           observer.disconnect();
 
           setTimeout(function() {
             document.documentElement.dispatchEvent(new CustomEvent('subscription:loaded', { bubbles: true }));
           }, 100); // Small delay just to be extra sure
 
           return;
         }
       }
     });
 
     observer.observe(observerTarget, { attributes: true, childList: true, subtree: true });
   }
 
   function waitToLoadAllSubscriptionForms() {
     const observerTargets = document.querySelectorAll('.appstle_stand_alone_selector');
     let loadedForms = 0;
 
     if (!observerTargets.length > 0) {
       return;
     }
 
     for (const observerTarget of observerTargets) {
       new MutationObserver(function(mutations) {
         for (const mutation of mutations) {
           if (mutation.type === 'attributes') {
             loadedForms++;
             this.disconnect();
             break;
           }
         }
 
         if (loadedForms === observerTargets.length) {
           setTimeout(function() {
             document.documentElement.dispatchEvent(new CustomEvent('subscription:loaded', { bubbles: true }));
           }, 100); // Small delay just to be extra sure
 
           return;
         }
       }).observe(observerTarget.parentNode, { attributes: true, childList: true, subtree: true });
     }
   }
 });
 
 
 window.addEventListener('subscription:loaded', function() {
 
   const observerTargets = document.querySelectorAll('.appstle_subscription_wrapper');
   const inputTargets = document.querySelectorAll('.appstle_subscription_wrapper input[type="radio"]');
 
   if (!observerTargets.length > 0) {
     return;
   }
 
   const initiallyHiddenSubDetails = document.querySelectorAll('.appstle_subscription_wrapper .appstle_hide_subsOption');
 
   for (const detail of initiallyHiddenSubDetails) {
     detail.classList.remove('appstle_hide_subsOption'); /* Appstle fix 2023.08.03 */
   }
 
   const observer = new MutationObserver(function(mutations) {
     for (const mutation of mutations) {
       if (mutation.type === 'childList') {
         mutation.target.closest('form').dispatchEvent(new CustomEvent('subscription:changed', { bubbles: true })); // Handled in theme.js _onSubscriptionChanged
         return;
       }
     }
   });
 
   for (const observerTarget of observerTargets) {
     observerTarget.closest('form').dispatchEvent(new CustomEvent('subscription:changed', { bubbles: true })); // Initial trigger
 
     observer.observe(observerTarget, { attributes: true, childList: true, subtree: true });
   }
 
   for (const inputTarget of inputTargets) {
     inputTarget.addEventListener('change', function() {
       this.closest('form').dispatchEvent(new CustomEvent('subscription:changed', { bubbles: true })); // Handled in theme.js _onSubscriptionChanged
     });
   }
 
   loadProductLineVariant();
 
   function loadProductLineVariant() {
     const url = new URL(window.location.href);
 
     if (!url.searchParams.has('variant')) {
       return;
     }
 
     const variantId = Number(url.searchParams.get('variant'));
     const productForms = document.querySelectorAll('.ProductForm[data-stage]');
 
     for (const productForm of productForms) {
       const productData = JSON.parse(productForm.querySelector('[data-product-json]').innerText);
       const productVariant = productData.product.variants.find(function(variant) {
         return variant.id === variantId;
       });
 
       if (!productVariant) {
         continue;
       }
 
       const stage = productForm.getAttribute('data-stage');
       const stageSelector = document.querySelector(`[value="${ stage }"]`);
 
       productForm.dispatchEvent(new CustomEvent('loaded:fromOutside', { detail: {
         variant: productVariant
       }}));
 
       stageSelector.click();
 
       break;
     }
   }
 });
 
 
 document.addEventListener('variant:changed', function(event) {
 
   const variantDetails = document.querySelector(".ProductMeta__VariantDetails");
   /* Show discount message on load */
   const currentForm = event.target;
   const singleDiscount = currentForm.querySelector('.DiscountMessage__Single');
   const multiDiscount = currentForm.querySelector('.DiscountMessage__Multiple');
   const multiPrice = multiDiscount.querySelector('.DiscountMessage__Price');
   const listElement = currentForm.querySelector(`input[value="${event.detail.variant.title}"]`).closest('.HorizontalList__Item');
 
   const totalCompare = currentForm.querySelector('.TotalPrice__Compare');
   
   if (listElement.querySelector('[data-single-unit-price]')) {
     singleDiscount.style.display = "flex";
     multiDiscount.style.display = "none";
     totalCompare !== null? totalCompare.innerText = "": void 0;
   
   } else {
     totalCompare !== null ? totalCompare.innerText = window.Currency.formatMoney(parseInt(listElement.querySelector('[data-save-price]').dataset.savePrice) + parseInt(listElement.querySelector('[data-save-price]').dataset.multiUnitPrice), window.theme.moneyFormat) : void 0;    
     singleDiscount.style.display = "none";
     multiDiscount.style.display = "flex";
     multiPrice.innerText = window.Currency.formatMoney(parseInt(listElement.querySelector('[data-save-price]').dataset.savePrice), window.theme.moneyFormat);
   }
   
   if (!variantDetails) {
     return;
   }
 
   for (child of variantDetails.children) {
     child.innerHTML = '<span class="ProductForm__Label">How do you want to receive your delivery?</span>';
   }
 
 });
 
 
 
 
 
 /**
 * ----------------------------------------------------------------------------
 * Price per Fl. Oz. calculation for PDP
 * ----------------------------------------------------------------------------
 */
 
 window.addEventListener('DOMContentLoaded', function() {
   const productPage = document.querySelector('.Product');
 
   if (!productPage) {
     return;
   }
 
   const forms = productPage.querySelectorAll('form[action="/cart/add"]');
 
   for (const form of forms) {
     
     const bulletPointsContainer = form.querySelector('.ProductMeta__BulletPoints');
 
     if (!bulletPointsContainer) {
       continue;
     }
 
     const pricePerFlOzContainer = bulletPointsContainer.querySelector('[data-price-per-fl-oz]');
     const totalFlOzContainer = bulletPointsContainer.querySelector('[data-total-fl-oz]');
 
     if (!pricePerFlOzContainer || !totalFlOzContainer) {
       continue;
     }
 
     const flOzText = totalFlOzContainer.innerText;
     const flOz = Number(flOzText.replace(/[^0-9]+/g, ""));
     const priceText = pricePerFlOzContainer.getAttribute('data-default-price');
     const multiplierText = pricePerFlOzContainer.getAttribute('data-multiplier');
     const multiplier = Number(multiplierText.replace(/[^0-9]+/g, ""));
     const price = Number(priceText.replace(/[^0-9]+/g, ""));
     const pricePerFlOz = Math.round(price / (flOz * multiplier));
 
     const pricePerFlOzText = window.Currency.formatMoney(pricePerFlOz, window.theme.moneyFormat);
 
     pricePerFlOzContainer.innerText = `${ pricePerFlOzText } per fl. oz.`;
     
   }
 
   for (const form of forms) {
     
     const rawWholesale = form.getAttribute('data-first-option');
     const wholeSaleAmount = isNaN(Number(rawWholesale)) ? 2 : Number(rawWholesale);
     const wholeSalePrice = Number(form.getAttribute('data-first-available-price'));
     
     let shippingPrice;
     if (window.theme.moneyWithCurrencyFormat.includes("Rs.")) {
         shippingPrice = window.Currency.formatMoney(90000, window.theme.moneyFormat);
     } else {
         shippingPrice = window.Currency.formatMoney(999, window.theme.moneyFormat);
     }
     
     let shippingText = '';
     
     const extractAmount = rawWholesale.match(/\d+/);
     const extractedAmount = extractAmount ? Number(extractAmount[0]) : 2;
     
     const selectedVariantTotalPrice = wholeSalePrice;
     if (selectedVariantTotalPrice < 12500) {
       shippingText = `+ ${ shippingPrice } paid shipping`;
     } else {
       shippingText = `Free express shipping`;
     }
 
     const singleUnitPrice = Math.round(wholeSalePrice / extractedAmount);
     const perUnitPriceContainers = document.querySelectorAll('.per-unit-price-container span');
 
     perUnitPriceContainers.forEach(function(perUnitPriceContainer) {
       perUnitPriceContainer.innerHTML = window.Currency.formatMoney(singleUnitPrice, window.theme.moneyFormat);
     });
 
     document.addEventListener('subscription:loaded', function() {
       
       form.dispatchEvent(new CustomEvent('subscription:changed', { bubbles: true, detail: { shippingText: shippingText } }));
 
       if (selectedVariantTotalPrice < 12500) {
         
         const subscribeContainers = document.querySelectorAll('.payAsYouGoPlansDropdownWrapper');
         const optionsContainers = document.querySelectorAll('.appstle_subscribe_option');
   
         subscribeContainers.forEach(function(subscribeContainer) {
           if (subscribeContainer) {
             subscribeContainer.classList.add('disabledOption');
           }
         });
         optionsContainers.forEach(function(optionsContainer) {                      
           if (optionsContainer) {
             optionsContainer.innerHTML = '';
             optionsContainer.textContent = 'You can subscribe to packages of 3 or more';
           }
         });
             
       }
       
     });
 
   }
   
 });
 
 
 document.addEventListener('variant:changed', function(event) {
   const targetForm = event.target.querySelector('form[action="/cart/add"]') || event.target;
   const variantPrice = event.detail.variant.price;
   
   const forms = document.querySelectorAll('form[action="/cart/add"]');
 
   
   for (const form of forms) {
     if (form !== targetForm) {
       continue;
     }
 
     const hiddenCartBtnElems = form.querySelectorAll('.ProductForm__AddToCart .hidden');
 
     for (const hiddenCartBtnElem of hiddenCartBtnElems) {
       hiddenCartBtnElem.classList.remove('hidden');
     }
 
     const addToCartBtn = form.querySelector('.ProductForm__AddToCart');
     addToCartBtn.disabled = false;
     addToCartBtn.removeAttribute('disabled');
 
     const bulletPointsContainer = form.querySelector('.ProductMeta__BulletPoints');
 
     if (!bulletPointsContainer) {
       continue;
     }
 
     const pricePerFlOzContainer = bulletPointsContainer.querySelector('[data-price-per-fl-oz]');
     const totalFlOzContainer = bulletPointsContainer.querySelector('[data-total-fl-oz]');
 
     if (!pricePerFlOzContainer || !totalFlOzContainer) {
       continue;
     }
 
     const transformedVariantName = event.detail.variant.option1.split('-')[0].toString().trim();
     const flOzText = totalFlOzContainer.innerText;
     const flOz = Number(flOzText.replace(/[^0-9]+/g, ""));
     const multiplier = isNaN(Number(transformedVariantName)) ? 1 : Number(transformedVariantName);
     const pricePerFlOz = Math.round(variantPrice / (flOz * multiplier));
     const pricePerFlOzText = window.Currency.formatMoney(pricePerFlOz, window.theme.moneyFormat);
 
     pricePerFlOzContainer.innerText = `${ pricePerFlOzText } per fl. oz.`;
     
   }
 
   for (const form of forms) {
     
     if (form !== targetForm) {
       continue;
     }
 
     const option = event.detail.variant.option1;
      const transformedVariantName = (option.includes('+') ? option.split('+')[0] : option.split('-')[0])
        .toString()
        .trim();
     
     const wholeSaleAmount = isNaN(Number(transformedVariantName)) ? 1 : Number(transformedVariantName);
     const newVariantPrice = event.detail.variant.price;
     const singleUnitPrice = Math.round(newVariantPrice / wholeSaleAmount);
     
     let shippingPrice;
     if (window.theme.moneyWithCurrencyFormat.includes("Rs.")) {
         shippingPrice = window.Currency.formatMoney(90000, window.theme.moneyFormat);
     } else {
         shippingPrice = window.Currency.formatMoney(999, window.theme.moneyFormat);
     }
 
     let shippingText = '';
 
     const packSizeInButton = form.querySelector('.packSizeInButton');
     const packSizeInCrossSell = document.querySelectorAll('.crossSellPackSize');
     
     if(packSizeInButton){
       packSizeInButton.innerHTML = event.detail.variant.option1;
     } 
 
     if (packSizeInCrossSell) {
       packSizeInCrossSell.forEach(element => {
         element.innerHTML = event.detail.variant.option1;
       });
     }
 
     /* HIER */

     const selectedVariantTotalPrice = event.detail.variant.price;


    if (selectedVariantTotalPrice < 12500) {
      shippingText = `+ ${ shippingPrice } paid shipping`;
 
       const oneTimeSelect = document.querySelector('.appstle_one_time_details_wrapper #appstle_selling_plan_label_10');  
       if(oneTimeSelect){
         oneTimeSelect.click();  
       }
       
       
     } else {
       shippingText = `Free express shipping`;
     }
 
     const perUnitPriceContainers = document.querySelectorAll('.per-unit-price-container span');
 
     perUnitPriceContainers.forEach(function(perUnitPriceContainer) {
       perUnitPriceContainer.innerHTML = window.Currency.formatMoney(singleUnitPrice, window.theme.moneyFormat);
     });
 
     
 
     setTimeout(function() {
       form.dispatchEvent(new CustomEvent('subscription:changed', { bubbles: true, detail: { shippingText: shippingText } }));
       if (wholeSaleAmount < 3) {
         
         const subscribeContainers = document.querySelectorAll('.payAsYouGoPlansDropdownWrapper');
         const optionsContainers = document.querySelectorAll('.appstle_subscribe_option');
   
         subscribeContainers.forEach(function(subscribeContainer) {
           if (subscribeContainer) {
             subscribeContainer.classList.add('disabledOption');
           }
         });
         optionsContainers.forEach(function(optionsContainer) {                      
           if (optionsContainer) {
             optionsContainer.innerHTML = '';
             optionsContainer.textContent = 'You can subscribe to packages of 3 or more';
           }
         });
             
       }
 
     }, 100);
   }
 
   for (const form of forms) {
     if (form !== targetForm) {
       continue;
     }
 
     const stockContainer = form.querySelector('[data-stock-text]');
     if(stockContainer){
         
       const variantIsAvailable = event.detail.variant.available;
       const availableMessage = "in stock";
       const unavailableMessage = "out of stock";
       const newElem = document.createElement('span');
 
       if (variantIsAvailable) {
         newElem.innerText = `${ availableMessage }`;
         newElem.classList.add('StockText__InStock');
       } else {
         newElem.innerText = `${ unavailableMessage }`;
         newElem.classList.add('StockText__OutOfStock');
       }
 
       // stockContainer.querySelector('p').innerHTML = newElem.outerHTML;
       // stockContainer.querySelector('p').innerHTML += ("&nbsp;" + stockText);
 
     }
   }
 });
 
 var KlaviyoSubscription = class KlaviyoSubscription extends HTMLElement {
   constructor() {
     super();
 
     this.input = this.querySelector('input');
     this.submit = this.querySelector('.KlaviyoModal__Submit');
     this.close = this.querySelector('.KlaviyoModal__Close');
     this.success = this.querySelector('.KlaviyoModal__Success');
     this.error = this.querySelector('.KlaviyoModal__Error');
 
     this.success.setAttribute('aria-hidden', 'true');
     this.error.setAttribute('aria-hidden', 'true');
 
     this.submit.addEventListener('click', this.submitForm.bind(this));
     this.close.addEventListener('click', this.closeModal.bind(this));
   }
 
   openModal(variantId, productId) {
     this.setAttribute('aria-hidden', 'false');
     this.setAttribute('data-variant-id', variantId);
     this.setAttribute('data-product-id', productId);
 
     this.submit.setAttribute('aria-hidden', 'false');
   }
 
   closeModal() {
     this.setAttribute('aria-hidden', 'true');
     this.removeAttribute('data-variant-id');
     this.removeAttribute('data-product-id');
 
     this.success.setAttribute('aria-hidden', 'true');
     this.error.setAttribute('aria-hidden', 'true');
   }
 
   submitForm(e) {
     e.preventDefault();
 
     const inputText = this.input.value;
     const variantId = this.getAttribute('data-variant-id');
     const productId = this.getAttribute('data-product-id');
 
     if (!inputText || inputText === '' || !inputText.includes('@')) {
       return;
     }
 
     if (!variantId || !productId) {
       return;
     }
 
     const urlParams = new URLSearchParams();
     const data = {
       "a": "WvzL2Z",
       "email": inputText,
       "variant": variantId,
       "product": productId,
       "platform": "shopify"
     };
 
     for (const key in data) {
       urlParams.append(key, data[key]);
     }
 
     const requestOptions = {
       method: 'POST',
       headers: {
         "Content-Type": "application/x-www-form-urlencoded"
       },
       body: urlParams,
       redirect: 'follow'
     };
 
     fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", requestOptions)
       .then(function(response) {
         return response.json();
       })
       .then(function(result) {
         if (result.status && result.status !== 200) {
           throw new Error(result.message);
         }
 
         this.success.setAttribute('aria-hidden', 'false');
         this.error.setAttribute('aria-hidden', 'true');
         this.submit.setAttribute('aria-hidden', 'true');
       }.bind(this))
       .catch(function(err) {
         this.error.innerText = err;
 
         // this.success.setAttribute('aria-hidden', 'true');
         // this.error.setAttribute('aria-hidden', 'false');
 
         this.success.setAttribute('aria-hidden', 'false');
         this.error.setAttribute('aria-hidden', 'true');
         this.submit.setAttribute('aria-hidden', 'true');
         
       }.bind(this));
   }
 }
 
 window.customElements.define('klaviyo-subscription', KlaviyoSubscription);
 
 
 
 
 
 
 /**
 * ----------------------------------------------------------------------------
 * Okaia: New Collection Pages
 * ----------------------------------------------------------------------------
 */
 
 // View buttons
 document.addEventListener('DOMContentLoaded', function() {
 
   var viewSwitchButtons = document.querySelectorAll('.viewSwitch button');
   var gridViewButton = document.querySelector('.gridView');
   var listViewButton = document.querySelector('.listView');
   var newProductList = document.querySelector('.CollectionInner__Products');
   var tableHeader = document.querySelector('.tableHeader');
 
   function applyView() {
 
     var view = localStorage.getItem('view');
     if (view === 'list') {
       newProductList.classList.add('listView');
       listViewButton.classList.add('active');
       tableHeader.classList.remove('hidden');
     } else {
       newProductList.classList.remove('listView');
       gridViewButton.classList.add('active');
       tableHeader.classList.add('hidden');
     }
   }
 
   if(viewSwitchButtons.length > 0){
   
     applyView();
     viewSwitchButtons.forEach(function(button) {
       button.addEventListener('click', function() {
         viewSwitchButtons.forEach(function(btn) {
           btn.classList.remove('active');
         });
         button.classList.add('active');
       });
     });
   
     listViewButton.addEventListener('click', function() {
       newProductList.classList.add('listView');
       localStorage.setItem('view', 'list');
     });
   
     gridViewButton.addEventListener('click', function() {
       newProductList.classList.remove('listView');
       localStorage.setItem('view', 'grid');
     });
 
   }
   
 });
 
 // Change pricing on collection pages
 document.addEventListener('DOMContentLoaded', function() {
   var checkbox = document.getElementById('checkPerUnit');
 
   if(checkbox){
 
     function applyPricing() {
       var priceUnits = document.querySelectorAll('.priceUnit');
       priceUnits.forEach(function(priceUnit) {
         if (!priceUnit.classList.contains('dontChange')) {
           if (checkbox.checked) {
             priceUnit.classList.add('hidden');
           } else {
             priceUnit.classList.remove('hidden');
           }
         }
       });
   
       var pricePacks = document.querySelectorAll('.pricePack');
       pricePacks.forEach(function(pricePack) {
         if (checkbox.checked) {
           pricePack.classList.remove('hidden');
         } else {
           pricePack.classList.add('hidden');
         }
       });
     }
   
     checkbox.addEventListener('change', applyPricing);
   
     // Start observing the newProductList for changes
     // var observer = new MutationObserver(applyPricing);
     // observer.observe(newProductList, { childList: true });
 
   }
   
 });
 
 
 
 // Toggle between USP list and price on list view
 document.addEventListener('DOMContentLoaded', function() {
   var priceInfoSwitches = document.querySelectorAll('.priceInfoSwitch');
   var priceContainers = document.querySelectorAll('.pricing');
   var infoContainers = document.querySelectorAll('.uspContainer');
   var isToggled = false;
 
   priceContainers.forEach(function(priceContainer) {
     priceContainer.style.display = 'block';
   });
 
   infoContainers.forEach(function(infoContainer) {
     infoContainer.style.display = 'none';
   });
 
   priceInfoSwitches.forEach(function(priceInfoSwitch) {
     var priceToggleImage = priceInfoSwitch.querySelector('div img:first-child');
     var infoToggleImage = priceInfoSwitch.querySelector('div img:last-child');
 
     priceInfoSwitch.addEventListener('click', function(e) {
       e.preventDefault();
 
       isToggled = !isToggled;
 
       priceContainers.forEach(function(priceContainer) {  
         priceContainer.style.display = isToggled ? 'none' : 'block';
       });
 
       infoContainers.forEach(function(infoContainer) {
         infoContainer.style.display = isToggled ? 'block' : 'none';
       });
 
       priceInfoSwitches.forEach(function(switchElement) {
         var switchImage = switchElement.querySelector('div img:first-child');
         switchImage.classList.toggle('hidden', isToggled);
         var infoImage = switchElement.querySelector('div img:last-child');
         infoImage.classList.toggle('hidden', !isToggled);
       });
     });
   });
 });
 
 
 /**
 * ----------------------------------------------------------------------------
 * Okaia: New Product Pages
 * ----------------------------------------------------------------------------
 */
 
 
 document.querySelectorAll('.NewVariantSelector .SizeSwatch__Radio').forEach(function(radio) {
   radio.addEventListener('click', function() {
 
     document.querySelectorAll('.sizeNotification span').forEach(function(span) {
       span.classList.add('hidden');
     });
 
     // document.querySelectorAll('.warningNotification').forEach(function(span) {
     //   span.classList.add('hidden');
     // });
     
     var packSize = radio.value;
     var firstPart;
     if (packSize.includes('+')) {
       firstPart = packSize.split('+')[0];
     } else {
       firstPart = packSize.split(' ')[0];
     }
     var messageSelector = '.sizeNotification .s' + firstPart;
     var messageElements = document.querySelectorAll(messageSelector);
 
     document.querySelectorAll(messageSelector).forEach(function(selector) {
       selector.classList.remove('hidden');
     });
 
     if (this.classList.contains('hasSaleRadio')) {
         document.querySelectorAll(".warningNotification").forEach(function(selector) {
           selector.classList.remove('hidden');
         });
     }
 
     
   });
 });
 
 
 
 function calculateDifference(value1, value2) {
     let number1 = parseFloat(value1.replace('€', '').replace(',', '.'));
     let number2 = parseFloat(value2.replace('€', '').replace(',', '.'));
     let difference = number1 - number2;
     return '€' + difference.toFixed(2).replace('.', ',');
 }
 
 
 
 
 
 
 /**
 * ----------------------------------------------------------------------------
 * Total pricing calculation near Add to cart button
 * ----------------------------------------------------------------------------
 */
 
 
 // Set pricing on intitial page load
 window.addEventListener('DOMContentLoaded', function(){
 
   const forms = document.querySelectorAll('form[action="/cart/add"]');
   for (const form of forms) {
 
     const wholeSalePrice = Number(form.getAttribute('data-first-available-price'));
     const variantName = form.getAttribute('data-first-option');
 
     const listElement = form.querySelector(`input[value="${variantName}"]`)?.closest('.HorizontalList__Item');
     const savePrice = listElement?.querySelector('[data-save-price]')?.dataset.savePrice;
 
     update_price(form, wholeSalePrice, savePrice);
 
     setTimeout(() => {
 
       update_subscription(form);
 
     }, 200);
 
   }
 
 });
 
 // Update price on variant change
 document.addEventListener('variant:changed', function(event) {  
   
   const targetFormStage = event.target.dataset.stage;
   const forms = document.querySelectorAll('form[action="/cart/add"]');
 
   for (const form of forms) {
 
     if(!event.detail.variant){
       return;
     }
 
     if(form.dataset.stage !== targetFormStage){
       continue;
     }
 
     const listElement = form.querySelector(`input[value="${event.detail.variant.title}"]`)?.closest('.HorizontalList__Item');
     const savePrice = listElement?.querySelector('[data-save-price]')?.dataset.savePrice;
     
     update_price(form, event.detail.variant.price, savePrice);
 
   }
 
 });
 
 // Check if subscription is active and change pricing accordingly
 window.addEventListener('change', function(event) {
 
   update_subscription(event);
   
 });
 
 
 // Function that handles the pricing change
 function update_price(form, totalPrice, savePrice, subscriptionDiscount = null){
   
   const totalPriceText = form.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .totalPriceNew');
   const originalPriceText = form.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .originalPriceNew');
   const discountPriceText = form.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .totalDiscount');
 
   if(!totalPriceText || !originalPriceText || !discountPriceText){
     return;
   }
 
   totalPriceText.innerHTML =  window.Currency.formatMoney(totalPrice, window.theme.moneyFormat);
   totalPriceText.dataset.rawPrice =  totalPrice;
 
   if (savePrice) {
 
     const originalPrice = Number(totalPrice) + Number(savePrice);
 
     originalPriceText.innerHTML =  window.Currency.formatMoney(originalPrice, window.theme.moneyFormat);
     originalPriceText.style.display = 'inline';
 
     discountPriceText.innerHTML = `You save ${window.Currency.formatMoney(savePrice, window.theme.moneyFormat)}`;
     discountPriceText.classList.add('saveActive');
 
   } else {
 
     originalPriceText.style.display = 'none';
 
     discountPriceText.innerHTML = `Size up for discount`;
     discountPriceText.classList.remove('saveActive');
 
   }

   update_sale_discount(form, totalPrice);

 
 }
 
 // Function that handles the subscription discount
 function update_subscription(data){
   
   let currentForm;
   if (data.nodeName === 'FORM') {
     currentForm = data;
   } else {
     currentForm = data.target.closest('.ProductForm');
   }
 
   const sellingPlanActive = currentForm.querySelector('.appstle_sub_widget');
 
   const totalPriceText = currentForm.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .totalPriceNew');
   const subscriptionDiscount = currentForm.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .subscriptionDiscount');
   const saleDiscount = currentForm.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .saleDiscount');
   const afterDiscountText = currentForm.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .afterDiscountText');

   const selectedVariant = currentForm.querySelector('.NewVariantSelector .SizeSwatch__Radio:checked');
   const packSize = selectedVariant ? parseInt(selectedVariant.value) : '';

   const totalPrice = totalPriceText.dataset.rawPrice;

   subscriptionDiscount.style.display = 'none';
   afterDiscountText.style.display = 'none';

   if(!sellingPlanActive || !sellingPlanActive.dataset.selectedSellingPlan){
     totalPriceText.innerHTML = window.Currency.formatMoney(totalPriceText.dataset.rawPrice, window.theme.moneyFormat);
      if (currentForm.dataset.sale && totalPriceText.dataset.rawPrice > 27500) {
         saleDiscount.innerHTML = `14% off`;
         saleDiscount.style.display = 'inline-block';
         totalPriceText.innerHTML =  window.Currency.formatMoney(totalPrice * 0.86, window.theme.moneyFormat);
      }
     return;
   }

 
   if(!totalPriceText){
     return;
   }
   
   totalPriceText.innerHTML = window.Currency.formatMoney(totalPriceText.dataset.rawPrice, window.theme.moneyFormat);
   subscriptionDiscount.style.display = 'none';
   //saleDiscount.style.display = 'none';
   afterDiscountText.style.display = 'none';

 
   if(!sellingPlanActive.dataset.selectedSellingPlan){
     return;
   }
   
   const newPrice = totalPriceText.dataset.rawPrice * 0.95;
   totalPriceText.innerHTML = window.Currency.formatMoney(newPrice, window.theme.moneyFormat);
   subscriptionDiscount.innerHTML = `5% extra off`;
   subscriptionDiscount.style.display = 'inline-block';

   //if (currentForm.dataset.sale && packSize > 4) {
    if (currentForm.dataset.sale && totalPrice > 27500) {
 
     saleDiscount.innerHTML = `3x 10% off`;
     saleDiscount.style.display = 'inline-block';
   
     const newPriceWithSale = totalPriceText.dataset.rawPrice * 0.95 * 0.90;
     totalPriceText.innerHTML = window.Currency.formatMoney(newPriceWithSale, window.theme.moneyFormat);
 
     afterDiscountText.innerHTML = `For the first 3 payments, then just ` + window.Currency.formatMoney(newPrice, window.theme.moneyFormat);
     afterDiscountText.style.display = 'block';
     
   }  
  
 }


 function update_sale_discount(form, newPrice){

   const saleDiscount = form.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .saleDiscount');
   const totalPriceText = form.querySelector('.Product__Wrapper .TotalPriceContainer .TotalPrice .totalPriceNew');
   
   saleDiscount.style.display = 'none';

   const packSizeNumber = form.querySelector('.NewVariantSelector input:checked')?.value.match(/\d+/)[0];
   console.log(newPrice);
   if(newPrice > 27500){
      
      saleDiscount.innerHTML = `14% off`;
      saleDiscount.style.display = 'inline-block';
      
      const newPriceWithSale = newPrice * 0.86;
      totalPriceText.innerHTML = window.Currency.formatMoney(newPriceWithSale, window.theme.moneyFormat);

   }

}

 
 /**
 * ----------------------------------------------------------------------------
 * Add products to cart with one click
 * ----------------------------------------------------------------------------
 */
 
 const quickAddToCartButtons = document.querySelectorAll('.cstm_ad_to_cart');
 
 quickAddToCartButtons.forEach(button => {
 
   button.addEventListener('click', function(e) {
     e.preventDefault();
     var ID = e.currentTarget.getAttribute("var_id");
 
     var productTitle = e.currentTarget.getAttribute('data-product-title');
     var productImage = e.currentTarget.getAttribute('data-product-image');
     var productPrice = e.currentTarget.getAttribute('data-product-price');
     
     
     var xhr = new XMLHttpRequest();
     xhr.open('POST', '/cart/add.js', true);
     xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
     xhr.onreadystatechange = function() {
       if (xhr.readyState === 4 && xhr.status === 200) {
         var data = JSON.parse(xhr.responseText);
         //document.dispatchEvent(new CustomEvent("product:added", { detail: { product: data } }));
 
         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
         }));
 
         openModal(productTitle, productImage, productPrice);
 
       }
     };
     xhr.send(JSON.stringify({
       quantity: 1,
       id: ID
     }));
   });
 
 });
 
 function openModal(productTitle, productImage, productPrice) {
 
    var modal = document.querySelector('.modal'); 
 
    if (!modal || !productTitle || !productImage || !productPrice) {
        return;
    }
 
 // Populate modal with product data
   var modalTitle = modal.querySelector('.modal-title');
   var modalImage = modal.querySelector('.modal-image');
   var modalPrice = modal.querySelector('.modal-price');
 
   if (modalTitle) {
     modalTitle.textContent = productTitle;
   }
   if (modalImage) {
     modalImage.src = productImage;
   }
   if (modalPrice) {
     modalPrice.textContent = window.Currency.formatMoney(productPrice, window.theme.moneyFormat);;
   }
       
    modal.style.display = 'flex';
 
 }
 function closeModal(event) {
 
    event.preventDefault(); 
    var modal = document.querySelector('.modal'); 
 
    if (modal) {
      modal.style.display = 'none';
    }
  }
 
 
 document.addEventListener('DOMContentLoaded', function() {
    var modalCloser = document.querySelector('.modalCloser');
    var overlayCloser = document.querySelector('.overlayCloser');
  
    if (modalCloser) {
      modalCloser.addEventListener('click', closeModal);
    }
  
    if (overlayCloser) {
      overlayCloser.addEventListener('click', closeModal);
    }
  });
 
 
 
 
 /**
 * ----------------------------------------------------------------------------
 * New cart functionality for upsells
 * ----------------------------------------------------------------------------
 */
 
 document.querySelectorAll('.upgrade-link').forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
  
      var currentLineItemId = this.getAttribute('data-current-line-item-id');
      var newVariantId = this.getAttribute('data-new-variant-id');
  
      // Remove the old product from the cart
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: currentLineItemId,
          quantity: 0
        })
      })
      .then(response => response.json())
      .then(data => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: newVariantId,
            quantity: 1
          })
        });
      })
      .then(response => response.json())
      .then(data => {
        reloadWithNotification();
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  });
 
 
  document.addEventListener('DOMContentLoaded', function() {
    var variantSelectors = document.querySelectorAll('.variantSelector');
  
    variantSelectors.forEach(function(selector) {
      selector.addEventListener('change', function(e) {
       
        var selectedVariantId = this.value;
 
        var option = this.options[this.selectedIndex];
        var selectedVariantPrice = option.getAttribute('data-variant-price');
        var selectedDiscountedPrice = option.getAttribute('data-discounted-price');
        
        var productId = this.getAttribute('data-linked-product-id');
 
        var price = document.querySelector('.unitPrice[data-linked-product-id="' + productId + '"] .discountedPrice');
        var comparePrice = document.querySelector('.unitPrice[data-linked-product-id="' + productId + '"] .compareAtPrice');
 
        var addToCartButton = document.querySelector('.cstm_ad_to_cart[data-linked-product-id="' + productId + '"]');
 
        if (addToCartButton) {
          addToCartButton.setAttribute('var_id', selectedVariantId);
          addToCartButton.setAttribute('data-product-price', selectedDiscountedPrice);
        }
 
        if(selectedDiscountedPrice){
          price.innerHTML = window.Currency.formatMoney(selectedDiscountedPrice, window.theme.moneyFormat);
          comparePrice.innerHTML = window.Currency.formatMoney(selectedVariantPrice, window.theme.moneyFormat);
        } else{
          price.innerHTML = window.Currency.formatMoney(selectedVariantPrice, window.theme.moneyFormat);
        }
 
      });
    });
  });
  
  
  
  document.querySelectorAll('.close').forEach(function(closeIcon) {
    closeIcon.addEventListener('click', function(event) {
      event.preventDefault();
  
      // Find the parent cartUsellCard div and remove it
      var cartUsellCard = this.closest('.cartUpsellCard');
      if (cartUsellCard) {
        cartUsellCard.remove();
      }
    });
  });
  
  function reloadWithNotification() {
    localStorage.setItem('notify', 'true');
     window.location.reload();
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    var notify = localStorage.getItem('notify');
    if (notify === 'true') {
      var notification = document.querySelector('.cartUpdateNotification');
      if (notification) {
        notification.style.display = 'flex';
        localStorage.removeItem('notify');
      }
    }
  });
 
   
  document.querySelectorAll('.close').forEach(function(closeIcon) {
    closeIcon.addEventListener('click', function(event) {
      event.preventDefault();
  
      // Find the parent cartUsellCard div and remove it
      var cartUsellCard = this.closest('.cartUpsellCard');
      if (cartUsellCard) {
        cartUsellCard.remove();
      }
    });
  });








function openUpsellModal() {
   console.log('HOOOI')
   var upsellModal = document.querySelector('.upsellModal');
   console.log(upsellModal)
   
   if (upsellModal) {
      // Display the modal
      upsellModal.style.display = 'flex';
      
      // Add event listener to close the modal when clicking outside
      upsellModal.addEventListener('click', function(event) {
         if (event.target === upsellModal) {
            closeUpsellModal();
         }
      });
      
      // Add event listener to the "Continue shopping" button to refresh the page
      var continueShoppingBtn = upsellModal.querySelector('.Button--secondary');
      if (continueShoppingBtn) {
         continueShoppingBtn.addEventListener('click', function(event) {
            event.preventDefault();
            window.location.reload();
         });
      }
      
      // Add event listener to the "Add to cart" button inside the modal
      var addToCartBtn = upsellModal.querySelector('.cstm_ad_to_cart');
      if (addToCartBtn) {
         addToCartBtn.addEventListener('click', function(event) {
            // The original add to cart functionality will still work
            // Just close the modal after it's done
            setTimeout(function() {
               closeUpsellModal();
            }, 100);
         });
      }
      
      // Prevent scrolling on the body
      document.documentElement.classList.add('no-scroll');
   }
}

function closeUpsellModal() {
   var upsellModal = document.querySelector('.upsellModal');
   
   if (upsellModal) {
      upsellModal.style.display = 'none';
      
      // Re-enable scrolling on the body
      document.documentElement.classList.remove('no-scroll');
   }
}

/* Announcement tooltip handled via HTML + CSS only */

/* tracking listener for product changes */
document.addEventListener('variant:changed', function (event) {
  const current = event.detail?.variant;
  const previous = event.detail?.previousVariant;

  if (!current || !window.Shopify?.analytics?.publish) return;

  const productForm = event.target.closest('.ProductForm') || event.target;
  const productJsonEl = productForm.querySelector('[data-product-json]');

  let product = null;
  if (productJsonEl) {
    try {
      product = JSON.parse(productJsonEl.innerText)?.product;
    } catch (e) {}
  }

  const payload = {
    product: product
      ? {
          id: product.id,
          title: product.title,
          handle: product.handle
        }
      : null,

    variant: {
      id: current.id,
      sku: current.sku,
      title: current.title,
      option1: current.option1,
      option2: current.option2,
      option3: current.option3,
      barcode: current.barcode,
      weight_grams: current.weight,
      requires_shipping: current.requires_shipping,
      taxable: current.taxable
    },

    previous_variant: previous
      ? {
          id: previous.id,
          sku: previous.sku,
          title: previous.title,
          option1: previous.option1,
          price: previous.price / 100
        }
      : null,

    pricing: {
      price: current.price / 100,
      compare_at_price: current.compare_at_price
        ? current.compare_at_price / 100
        : null,

      price_delta: previous
        ? (current.price - previous.price) / 100
        : null
    },

    inventory: {
      available: current.available,
      inventory_management: current.inventory_management
    },

    subscription: {
      requires_selling_plan: current.requires_selling_plan,
      selling_plan_group_ids: current.selling_plan_allocations?.map(
        sp => sp.selling_plan_group_id
      ) || [],
      selling_plan_prices: current.selling_plan_allocations?.map(
        sp => sp.price / 100
      ) || []
    },

    media: {
      image: current.featured_image?.src
        ? `https:${current.featured_image.src}`
        : null
    },

    context: {
      stage: productForm.dataset.stage || null,
      url: window.location.href
    }
  };

  Shopify.analytics.publish('product_variant_changed', payload);
});

